module.exports = __webpack_public_path__ + "static/media/boat-img-8.14120b35.jpg";